import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'
import { css } from 'styled-components';

interface IProps {
  className?: string;
  children?: React.ReactNode;
  padded?: boolean | 'very';
  stretched?: boolean;
  dark?: boolean;
}

const SectionBase = (props: IProps) =>
  <div className={props.className}>{props.children}</div>

const Section = styled(SectionBase)`
  position: relative;
  ${p => p.padded && p.padded == 'very' && css`padding: 25px 25px 25px 25px;`}
  ${p => p.padded && p.padded != 'very' && css`padding: 5px 25px 5px 25px;`}
  ${p => p.stretched && css`flex:1;`}
  ${p => p.dark && css`background: #eee;`}
  margin-bottom: 5px;
`

export { Section }